import styled from '@emotion/styled';
import theme from '@travelnest/merlin.theme';
import * as React from 'react';

import { Button, PresetThemes } from '@travelnest/merlin.button';
import { ICalendarEvent } from '../../components/calendar/types';

const pluralise = (xs: any[]) => xs.length > 1 ? 's' : '';

interface ISelectionActionsProps {
	selectedNights: Date[];
	selectedEvents: ICalendarEvent[];
	showBlockUnblockPanel: () => any;
}

export const SelectionActions: React.FC<ISelectionActionsProps> = (props) => {
	const { selectedNights, showBlockUnblockPanel } = props;
	const showBlockUnblock = selectedNights.length > 0;

	// Atm we allow users to block over any event on the FE (the availability service handles what actually gets blocked).
	const disableBlockUnblock = false;

	return <>
		{showBlockUnblock &&
			<Button onClick={showBlockUnblockPanel}
				disabled={disableBlockUnblock}>
				Block/unblock night{pluralise(selectedNights)}
			</Button>}
	</>;
};

const MobileWrapper = styled.div`
	position: fixed;
	bottom: 0; /** this is the height of the Product Frame mobile navigation fixed to the bottom */
	left: 0;
	right: 0;
	z-index: 2147483601; /* Must sit above Intercom at z-index 2147483600 ... */
	padding: 25px ${theme.layout.spacing.large};
	box-shadow: 0 -10px 10px #00000014;
	background-color: #CCE4DE; // this colour is in merlin theme but requires upgrade to new major v
`;

const ContentWrapper = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr;

	.primary {
		margin-right: ${theme.layout.spacing.standard};
	}

	.merlin-button__content {
		margin: auto;
	}
`;

interface IActionDrawerProps {
	selectedNights: Date[];
	hide: boolean;
	showContextualActions: () => any;
	onCancel: () => any;
}

export const CallToActionDrawerPP: React.FC<IActionDrawerProps> = (props) => {
	const { selectedNights, showContextualActions, hide, onCancel } = props;
	const show = selectedNights.length !== 0 && !hide;

	return <>
		{show && <MobileWrapper>
			<ContentWrapper>
				<Button
					className="primary"
					buttonType={PresetThemes.Primary}
					onClick={showContextualActions}>
					Update {selectedNights.length} night{pluralise(selectedNights)}
				</Button>
				<Button buttonType={PresetThemes.Neutral} onClick={onCancel}>
					Cancel
				</Button>
			</ContentWrapper>
		</MobileWrapper>}
	</>;
};
